import {
  requestPostFileBlob,
  requestGet,
  requestPost,
  requestPut,
} from "../config/Api";

export const getUnlinkedNotificationCertificates = (params) =>
  requestGet("unlinked/notification/certificates", { params });

export const getUnlinkedNotificationCertificateById = (id) =>
  requestGet(`unlinked/notification/certificates/${id}`);

export const downloadUnlinkedNotificationCertificate = (id) =>
  requestPostFileBlob(`unlinked/notification/certificates/${id}/download`);

export const linkUnlinkedNotificationCertificate = (id, payload) =>
  requestPost(`unlinked/notification/certificates/${id}/link`, payload);

export const discardUnlinkedNotificationCertificate = (id) =>
  requestPost(`unlinked/notification/certificates/${id}/discard`);

export const searchLegalFilesForUnlinkedNotificationCertificate = (search) =>
  requestGet("unlinked/notification/certificates/search/legal/files", {
    search,
  });

export const updateUnlinkedNotificationCertificate = (id, payload) =>
  requestPut(`unlinked/notification/certificates/${id}`, payload);
